/*eslint-disable*/
import api from '../';

class AchievementsApi {
    static getAchievements(params) {
        return api.axios.get('/achievements', { params }).then(response => response.data);
    }
}

export default AchievementsApi;
